import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { useContactContext } from "@/contexts/contact";
import { formatTextWithHtml } from "@/utils";
export const MobileLegalNoticeSectionModal = () => {
    const { t } = useI18n();
    const { toggleMobileLegalNoticeSectionModal, isMobileLegalNoticeSectionModalOpen, } = useContactContext();
    const legalText = t("contact.form.legal_notice_detail_text");
    return (_jsx(Modal, { isDismissable: true, trigger: () => null, isOpen: isMobileLegalNoticeSectionModalOpen, onOpenChange: toggleMobileLegalNoticeSectionModal, children: _jsx(Box, { paddingTop: 0, paddingLeft: 12, paddingRight: 12, typography: "typography.body.16.regular", dangerouslySetInnerHTML: { __html: formatTextWithHtml(legalText) } }) }));
};
